import styled from 'styled-components';

const SettingsOptions = styled.div`
  margin-top: 25px !important;
`;

export const Styled = {
  SettingsOptions
};
